<div class="paragraph" :class="`paragraph-size_${size} paragraph-weight_${weight}`"><slot></slot></div>